import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { LabTech } from '../LabTechsContext'
import { useSingleUserColumn } from 'components/CIMSTable/common/hooks/useSingleUserColumn'

export function useColumns(): CIMSColumn<LabTech>[] {
  return [
    useNameColumn({
      help: HelpMessage.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    useSingleUserColumn({
      title: 'User',
      width: 'auto',
      help: HelpMessage.Concrete.LabTechs.LabTechs.User({ header: true }),
      user: ({ user }) => user,
    }),
  ]
}
